import { useEffect, useMemo, useState } from 'react';
import { listGlobalTags } from 'services/Settings';
import { totalCountEvent } from 'services/generalServices';

export function useGlobalTagList(practiceAreaId = '') {
  const [tagList, setTagList] = useState([]);
  const [isLoading, setisLoading] = useState(false);

  const loadGlobalList = (practiceAreaId = '') => {
    setisLoading(true);
    totalCountEvent('global-tag')
      .then((response) => {
        listGlobalTags(response.data, '', '', '', practiceAreaId)
          .then((response) => {
            setTagList(response?.data?.global_tag);
          })
          .catch((error) => console.log(error));
      })
      .finally(() => setisLoading(false));
  };

  useEffect(() => {
    loadGlobalList(practiceAreaId);
  }, [practiceAreaId]);

  const formattedGlobalTag = useMemo(() => {
    if (tagList?.length > 0) {
      let tagsArray = [];
      tagList.forEach((item) => {
        tagsArray.push({ name: item.tag, value: item.tag });
      });
      return tagsArray;
    }
  }, [tagList]);

  return { globalList: tagList, formattedGlobalTag, loadGlobalList, isTagsLoading: isLoading };
}
